import React, { useCallback, useEffect, useState } from 'react';
import { Button, Card, Col, Form, Nav, Row, Tab } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { getBrandingAPI, updateBrandingAPI, uploadLogoAPI } from '../../../Services/mockApi';
import PageHeader from '../../../Components/shared/PageHeader';
import LoadingSkeleton from '../../../Components/shared/LoadingSkeleton';
import { companyUrl } from '../../../utils/mhNav';
import styles from './Branding.module.scss';

export default function Branding() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [b, setB] = useState(null);
  const [previewTab, setPreviewTab] = useState('portal');

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await getBrandingAPI();
      setB(res.data);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const save = async () => {
    await updateBrandingAPI(b);
    toast.success('Branding saved');
  };

  if (error && !b) {
    return (
      <div>
        <PageHeader title="Branding" breadcrumbs={[{ label: 'Company', path: companyUrl('settings') }]} />
        <Button onClick={load}>Retry</Button>
      </div>
    );
  }

  return (
    <div>
      <PageHeader title="Branding" breadcrumbs={[{ label: 'Company', path: companyUrl('dashboard') }, { label: 'Settings', path: companyUrl('settings') }, { label: 'Branding' }]} />
      {loading || !b ? (
        <LoadingSkeleton rows={5} cols={2} />
      ) : (
        <Row className="g-3">
          <Col lg={6}>
            <Card>
              <Card.Body>
                <Form.Group className="mb-2">
                  <Form.Label>Primary color</Form.Label>
                  <Form.Control type="color" value={b.primaryColor} onChange={(e) => setB({ ...b, primaryColor: e.target.value })} />
                  <Form.Text>{b.primaryColor}</Form.Text>
                </Form.Group>
                <Form.Group className="mb-2">
                  <Form.Label>Secondary color</Form.Label>
                  <Form.Control type="color" value={b.secondaryColor} onChange={(e) => setB({ ...b, secondaryColor: e.target.value })} />
                </Form.Group>
                <Form.Group className="mb-2">
                  <Form.Label>Logo</Form.Label>
                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={async (e) => {
                      const file = e.target.files?.[0];
                      if (!file) return;
                      const r = await uploadLogoAPI({ name: file.name });
                      setB((prev) => ({ ...prev, logoUrl: r.data.url }));
                    }}
                  />
                  <div className="small text-muted mt-1">PNG/SVG, max 2MB recommended.</div>
                </Form.Group>
                <Form.Group className="mb-2">
                  <Form.Label>Favicon (32×32)</Form.Label>
                  <Form.Control type="file" accept="image/*" />
                </Form.Group>
                <Form.Group className="mb-2">
                  <Form.Label>Bot display name</Form.Label>
                  <Form.Control value={b.botDisplayName} onChange={(e) => setB({ ...b, botDisplayName: e.target.value })} />
                </Form.Group>
                <Form.Group className="mb-2">
                  <Form.Label>Portal title</Form.Label>
                  <Form.Control value={b.portalTitle} onChange={(e) => setB({ ...b, portalTitle: e.target.value })} />
                </Form.Group>
                <div className="d-flex gap-2">
                  <Button variant="outline-secondary" onClick={() => toast.info('Upload logo (mock)')}>Upload Logo</Button>
                  <Button onClick={save}>Save</Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={6}>
            <Card>
              <Card.Body>
                <Tab.Container activeKey={previewTab} onSelect={(k) => setPreviewTab(k || 'portal')}>
                  <Nav variant="tabs" className="mb-2">
                    <Nav.Item><Nav.Link eventKey="portal">Portal</Nav.Link></Nav.Item>
                    <Nav.Item><Nav.Link eventKey="teams">Teams Card</Nav.Link></Nav.Item>
                    <Nav.Item><Nav.Link eventKey="email">Email Header</Nav.Link></Nav.Item>
                  </Nav>
                  <Tab.Content>
                    <Tab.Pane eventKey="portal">
                      <div className={styles.miniShell} style={{ borderColor: b.primaryColor }}>
                        <div className={styles.miniSide} style={{ background: b.primaryColor }}>
                          {b.logoUrl && <img src={b.logoUrl} alt="" className={styles.miniLogo} />}
                        </div>
                        <div className={styles.miniMain}>{b.portalTitle}</div>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="teams">
                      <div className="border rounded p-2" style={{ borderTop: `4px solid ${b.primaryColor}` }}>
                        <strong>{b.botDisplayName}</strong>
                        <div className="small text-muted">Adaptive card preview</div>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="email">
                      <div className="border-bottom pb-2 mb-2" style={{ borderColor: b.primaryColor }}>
                        {b.logoUrl && <img src={b.logoUrl} alt="" height={32} className="me-2" />}
                        <strong>{b.portalTitle}</strong>
                      </div>
                      <div className="small text-muted">Email body…</div>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
    </div>
  );
}
